import type searchEn from "./search.en";

const searchAr: Record<keyof typeof searchEn, string> = {
  "nav.search_discovery": "البحث والاكتشاف",

  "palette.open": "بحث",
  "palette.placeholder": "ابحث في الصفحات والإعدادات والمنتجات والطلبات والعملاء",
  "palette.empty": "لا توجد نتائج لـ «{q}»",
  "palette.hint": "اكتب للبحث. ↑ ↓ للتنقل، Enter للفتح، Esc للإغلاق.",
  "palette.group.product": "المنتجات",
  "palette.group.order": "الطلبات",
  "palette.group.customer": "العملاء",
  "palette.unavailable": "البحث غير متاح الآن.",

  "sd.title": "البحث والاكتشاف",
  "sd.tab.filters": "عوامل التصفية",
  "sd.tab.synonyms": "المرادفات",
  "sd.tab.searches": "عمليات البحث",
  "sd.filters_hint": "تظهر عوامل التصفية في صفحات المجموعات والبحث بهذا الترتيب، ويمكن للمتسوقين الجمع بينها.",
  "sd.add_filter": "إضافة عامل تصفية",
  "sd.no_filters": "لا توجد عوامل تصفية. لن يرى المتسوقون خيارات التصفية في متجرك.",
  "sd.filter_label": "التسمية",
  "sd.filter_source": "المصدر",
  "sd.kind.availability": "التوفر",
  "sd.kind.price": "السعر",
  "sd.kind.product_type": "نوع المنتج",
  "sd.kind.vendor": "المورّد",
  "sd.kind.tag": "الوسم",
  "sd.kind.category": "الفئة",
  "sd.kind.option": "خيار المنتج",
  "sd.kind.metafield": "حقل مخصص للمنتج",
  "sd.move_up": "تحريك لأعلى",
  "sd.move_down": "تحريك لأسفل",
  "sd.synonyms_hint": "الكلمات في المجموعة الواحدة تجد المنتجات نفسها. استخدمها للتهجئات المختلفة وللغتين، مثل «عباية، abaya، abaaya».",
  "sd.add_group": "إضافة مجموعة مرادفات",
  "sd.group_terms": "الكلمات (مفصولة بفواصل)",
  "sd.no_synonyms": "لا توجد مجموعات مرادفات بعد.",
  "sd.synonyms_note": "تنعكس التغييرات على نتائج البحث خلال دقائق.",
  "sd.top": "أكثر عمليات البحث",
  "sd.no_results": "عمليات بحث بلا نتائج",
  "sd.no_results_hint": "أضف مرادفات أو منتجات لهذه الكلمات.",
  "sd.term": "البحث",
  "sd.count": "المرات",
  "sd.results": "النتائج",
  "sd.nothing_yet": "لا توجد عمليات بحث خلال آخر 30 يوماً.",
  "sd.rebuild": "إعادة بناء فهرس البحث",
  "sd.rebuild_body": "يعيد بناء كل المنتجات والصفحات والمقالات في البحث. يبقى متجرك قابلاً للبحث أثناء ذلك.",
  "sd.rebuilding": "تتم إعادة بناء فهرس البحث…",
  "sd.disabled": "خدمة البحث غير متصلة. يستخدم متجرك البحث الأساسي حتى تتصل.",
  "sd.last_30": "آخر 30 يوماً",
};

export default searchAr;
